// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2dU6J","signatureBlock":"Footer_signatureBlock__3QY7d","signature":"Footer_signature__3WhI8"};